// extracted by mini-css-extract-plugin
export default {"Main":"Cas_Main__GOZHo","Dialog":"Cas_Dialog__wlxBC","extraPart":"Cas_extraPart__KQ9Q7","Code":"Cas_Code__3b07p"};